import React from "react";
import SalesOrderDetail from "./SalesOrderDetail";

const SalesOrderDetailPage: React.FC = () => {
  return <SalesOrderDetail />;
};

export default SalesOrderDetailPage;
